<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-20 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Please select your order
    </Teleport>

    <div class="cf-flex cf-flex--column cf-flex--gap-12 cf-text-align-left">
      <open-order
        v-for="order in openOrders"
        :key="order.orderId"
        :order="order"
        @callback-handler="callbackHandler"
      />
    </div>
  </div>
</template>


<script>
  import OpenOrder from './open-order/index.vue';

  export default {
    name: 'SelectTableTopDeviceOrder',

    components: {
      OpenOrder
    },

    props: {
      openOrders: {
        type: Array,
        required: true
      }
    },

    methods: {
      callbackHandler() {
        this.$emit('callback-handler');
      }
    }
  };
</script>
